export default {"src":"/_next/static/image/assets/Illustrations/twitter 1.11343163e270c9ae9821be0a662419a8.svg","height":24,"width":24};